import React from 'react';
import s from '../../styles/corporate/Corporate.module.css';
import { GROWTH } from './data';
import { useCountUp } from './hooks';

/** 2021 → 2025 매출 증가율 */
const CorpGrowth = () => {
  const [ref, value] = useCountUp(GROWTH.value);

  return (
    <section className={s.growth}>
      <div className={s.growthGlow} aria-hidden="true" />
      <div className={`${s.growthInner} ${s.reveal}`} ref={ref}>
        <div className={s.mono}>{GROWTH.eyebrow}</div>
        <div className={s.growthValue}>
          <span className={s.growthNum}>{value.toLocaleString('ko-KR')}</span>
          <span className={s.growthUnit}>%</span>
        </div>
        <div className={s.growthCaption}>{GROWTH.caption}</div>
        <h2 className={s.growthHeadline}>
          {GROWTH.headline[0]}
          <br />
          {GROWTH.headline[1]}
        </h2>
      </div>
    </section>
  );
};

export default CorpGrowth;
